/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIOfferFileSearchResult
 */
export interface APIOfferFileSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIOfferFileSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIOfferFileSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIOfferFileSearchResult
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof APIOfferFileSearchResult
     */
    fileName?: string;
    /**
     * 
     * @type {number}
     * @memberof APIOfferFileSearchResult
     */
    fileSize?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIOfferFileSearchResult
     */
    storedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIOfferFileSearchResult
     */
    lastModifiedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIOfferFileSearchResult
     */
    offerId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIOfferFileSearchResult
     */
    requestId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIOfferFileSearchResult
     */
    requestCertificate?: string;
}

/**
 * Check if a given object implements the APIOfferFileSearchResult interface.
 */
export function instanceOfAPIOfferFileSearchResult(value: object): value is APIOfferFileSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function APIOfferFileSearchResultFromJSON(json: any): APIOfferFileSearchResult {
    return APIOfferFileSearchResultFromJSONTyped(json, false);
}

export function APIOfferFileSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIOfferFileSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'key': json['key'] == null ? undefined : json['key'],
        'fileName': json['file_name'] == null ? undefined : json['file_name'],
        'fileSize': json['file_size'] == null ? undefined : json['file_size'],
        'storedAt': json['stored_at'] == null ? undefined : (new Date(json['stored_at'])),
        'lastModifiedAt': json['last_modified_at'] == null ? undefined : (new Date(json['last_modified_at'])),
        'offerId': json['offer_id'] == null ? undefined : json['offer_id'],
        'requestId': json['request_id'] == null ? undefined : json['request_id'],
        'requestCertificate': json['request_certificate'] == null ? undefined : json['request_certificate'],
    };
}

export function APIOfferFileSearchResultToJSON(value?: APIOfferFileSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'key': value['key'],
        'file_name': value['fileName'],
        'file_size': value['fileSize'],
        'stored_at': value['storedAt'] == null ? undefined : ((value['storedAt'] as any).toISOString()),
        'last_modified_at': value['lastModifiedAt'] == null ? undefined : ((value['lastModifiedAt'] as any).toISOString()),
        'offer_id': value['offerId'],
        'request_id': value['requestId'],
        'request_certificate': value['requestCertificate'],
    };
}

